import styled from "styled-components";
import {Colors, FlexBox} from "@brg/ui";
import {LayoutConst} from "../../../../../../core";

export const BookCardsWrapper = styled(FlexBox)`
  margin: 0 auto;
  max-width: 1152px;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 888px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: calc(100% - 32px);
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: calc(100% - 20px);
  }
`

export const BookCardsTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.projectView.titleColor};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-weight: 600;
    font-size: 26px;
    line-height: 32px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
  }
`

export const BookCardsCaption = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  white-space: pre-line;
  color: ${Colors.galBlack47};
`

export const BookCardsButton = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  border: 1px solid ${Colors.galBlack31};
  border-radius: 3px;
  padding: 8px 24px;

  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};
`

export const EmptyCardsTitle = styled(FlexBox)`
  font-size: 26px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};
  justify-content: center;
  text-align: center;

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 17px;
    line-height: 22px;
  }
`

export const EmptyCardsDescription = styled(FlexBox)`
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack73};
  justify-content: center;
  text-align: center;

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
  }
`import styled from "styled-components";
import {Colors, FlexBox} from "@brg/ui";
import {LayoutConst} from "../../../../../../core";

export const BookCardsWrapper = styled(FlexBox)`
  margin: 0 auto;
  max-width: 1152px;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 888px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: calc(100% - 32px);
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: calc(100% - 20px);
  }
`

export const BookCardsTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.projectView.titleColor};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-weight: 600;
    font-size: 26px;
    line-height: 32px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
  }
`

export const BookCardsCaption = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  white-space: pre-line;
  color: ${Colors.galBlack47};
`

export const BookCardsButton = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  border: 1px solid ${Colors.galBlack31};
  border-radius: 3px;
  padding: 8px 24px;

  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};
`

export const EmptyCardsTitle = styled(FlexBox)`
  font-size: 26px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};
  justify-content: center;
  text-align: center;

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 17px;
    line-height: 22px;
  }
`

export const EmptyCardsDescription = styled(FlexBox)`
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack73};
  justify-content: center;
  text-align: center;

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
  }
`